// removed by extract-text-webpack-plugin
module.exports = {"vpCampaignLandingPageContainer":"vpCampaignLandingPageContainer___2ean-","vpSubmitSuccessH1":"vpSubmitSuccessH1___3ixwr"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/CampaignLandingPage/SubmissionSuccess.module.less
// module id = 3832
// module chunks = 33